import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class LoaderService {

    private loaderSubject = new Subject<boolean>();
    loaderState = this.loaderSubject.asObservable();
    private loaderDisabled: boolean = false;

    constructor() { }

    show() {
        this.loaderSubject.next(true);
    }

    hide() {
        this.loaderSubject.next(false);
    }

    setDisabled(ifDisabled: boolean) {
        this.loaderDisabled = ifDisabled;
        this.hide();
    }

    ifDisabled(): boolean {
        return this.loaderDisabled;
    }
}